import React from "react";
import { twMerge } from "tailwind-merge";
import type { ComplianceService } from "../../store/@types/portal";

type IServiceCard = {
  service: ComplianceService;
  selected: boolean;
  onToggle: (serviceId: string) => void;
};

const ServiceCard: React.FC<IServiceCard> = ({
  service,
  selected,
  onToggle,
}) => {
  const Icon = service.icon;

  return (
    <button
      type="button"
      onClick={() => onToggle(service.id)}
      aria-pressed={selected}
      className={twMerge(
        "flex w-full flex-col items-start gap-3 rounded-xl border px-5 py-4 text-left transition-colors",
        selected
          ? "border-transparent bg-[#0B1526] text-white"
          : "border-gray-100/10 bg-gray-50/10 text-slate-900 hover:border-primary-300 hover:bg-primary-50/40",
      )}
    >
      <span
        className={twMerge(
          "flex h-9 w-9 lg:h-12 lg:w-12 items-center justify-center rounded-lg",
          selected
            ? "bg-white/50 text-[#0B1526]"
            : "bg-primary-100/10 text-primary-600",
        )}
      >
        <Icon stroke={1.75} className="h-5 w-5 lg:h-7 lg:w-7" />
      </span>
      <span>
        <span className="block text-sm lg:text-lg font-semibold">
          {service.name}
        </span>
        <span
          className={twMerge(
            "mt-0.5 block text-xs lg:text-sm",
            selected ? "text-slate-300" : "text-slate-500",
          )}
        >
          {service.description}
        </span>
      </span>
    </button>
  );
};

export default ServiceCard;
